var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBz = function SvgBz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 170 94",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.2,
    y: 46.4,
    transform: "matrix(-1.079642e-10 -1 1 -1.079642e-10 48.0387 216.4446)",
    width: 20,
    height: 75.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.9,
    y: -27.7,
    transform: "matrix(-1.071471e-10 -1 1 -1.071471e-10 122.1595 141.7536)",
    width: 20,
    height: 74.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.8,-0.2 160.3,-0.2 94.5,74 109.6,87.3 169.8,19.7"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "0.1,-0.2 52.2,-0.2 52.2,19.9 15.6,19.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,45.4c7.6-3.5,12.4-11.4,12.4-20.9c0-12-8.7-24.8-27.8-24.8H8.8v94.4h48.7c17.1,0,28.1-10.3,28.1-26.3       C85.7,57.8,79.8,48.9,71.5,45.4z M52.8,37H28.9V19.8h23.9c5.9,0,9.8,3.4,9.8,8.6C62.5,33.8,58.9,37,52.8,37z M28.9,54.2h26.2       c6.9,0,11.4,3.9,11.4,10c0,6.4-4.2,10-11.4,10H28.9V54.2z"
  }))));
};
export { SvgBz as ReactComponent };